var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical-products"},[_c('div',{staticClass:"vertical-products-list"},_vm._l((_vm.products),function(product,index){return _c('ProductCardVertical',{key:index,attrs:{"product":product}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }